__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "fund-center-front";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("axios", "0.22.0", () => (__webpack_require__.e(505).then(() => (() => (__webpack_require__(72505))))));
			register("axios", "1.21.0", () => (__webpack_require__.e(936).then(() => (() => (__webpack_require__(75936))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-intl", "6.8.9", () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(914), __webpack_require__.e(820)]).then(() => (() => (__webpack_require__(66363))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(942), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(850)]).then(() => (() => (__webpack_require__(75942))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("recharts", "3.10.1", () => (Promise.all([__webpack_require__.e(606), __webpack_require__.e(682), __webpack_require__.e(494), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(84494))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};